import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Row, Stack } from 'react-bootstrap';
import { DealProps } from 'states/initialState';
import { DecimalFormat, IntegerFormat, MoneyFormat } from '../Common/TextFormat';

interface ModalProps {
  deal: DealProps;
  email: string;
}

const ConfirmationModal = ({ deal, email }: ModalProps) => {
  const intl = useIntl();
  return (
    <Row xs={1} md={2} className="pt-1 gy-3 gx-5 fs-5 justify-content-end">
      <Stack direction="horizontal">
        <FormattedMessage id="confirmation.product" />
        <span className="text-secondary ms-auto">
          <FormattedMessage id="confirmation.tl" />
        </span>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.origFee" />
        <MoneyFormat value={deal.originationFee} className='ms-auto'/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.loanAmt" />
        <MoneyFormat value={deal.loanAmount} className='ms-auto' cents={false}/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.apr" />
        <DecimalFormat className='ms-auto' value={deal.apr} suffix="%"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.disbursementAmt" />
        <MoneyFormat value={deal.disbursementAmount} className='ms-auto'/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.cod" />
        <DecimalFormat value={deal.centsOnDollar} decimalScale={3} className='ms-auto'/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.payback" />
        <MoneyFormat value={deal.totalAmountPaidBack} className='ms-auto'/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.payAmt" />
        <MoneyFormat value={deal.payment}  className='ms-auto'/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.term" />
        <IntegerFormat value={deal.term} className="ms-auto"
          suffix={intl.formatMessage({ id: 'selectedDeal.months' })}
        />
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.numPaymts" />
        <IntegerFormat value={deal.numberOfPayments} className="ms-auto"/>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="selectedDeal.paymentFreq" />
        <span className="ms-auto text-secondary">{deal.paymentFrequency}</span>
      </Stack>
      <Stack direction="horizontal">
        <FormattedMessage id="common.email" />
        <a
          href={`mailto: ${email}`}
          className="ms-auto fw-600 ps-2 text-break text-end"
        >
          {email}
        </a>
      </Stack>
      <Stack direction="horizontal" className="mt-4 mb-0 fs-4">
        <FormattedMessage id="confirmation.commission" />
        <MoneyFormat value={deal.commission} className="ms-auto"/>
      </Stack>
    </Row>
  );
};

export default ConfirmationModal;
